import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function OrderByV2(props, childrenComponents) {
	return {
		componentName: 'OrderByV2',
		componentId: uuidv4(),
		draggableType: 'Container',
		droppableType: 'NONE',
		props: _.merge({}, props),
		childrenComponents,
	};
}
